import { createSelector } from 'reselect'

const selectUser = state => state.user

export const selectCurrentUser = createSelector([selectUser], user => user.currentUser)

export const selectUserAccounts = createSelector([selectUser], user => user.userAccounts)

export const selectLoading = createSelector([selectUser], user => user.loading)

export const selectSuccess = createSelector([selectUser], user => user.success)

export const selectSuccessData = createSelector([selectUser], user => user.successData)

export const selectSsAccessToken = createSelector([selectUser], user => user.ssAccessToken)

export const selectLatestSessions = createSelector([selectUser], user => user.latestSessions)

export const selectIpData = createSelector([selectUser], user => user.ipData)

export const selectUserOnboardingFee = createSelector([selectUser], user => user.onboardingFee)

export const selectEnabledServices = createSelector([selectUser], user => user.enabledServices)

export const selectPersonalAccount = createSelector([selectUser], user => user.personalAccount)

export const selectUserEmailStatus = createSelector([selectUser], user => user.userEmailStatus)

export const selectLoader = createSelector([selectUser], user => user.loader)

export const selectCanCreateCompany = createSelector([selectUser], user => user.canCreateCompany)

export const selectUserPermissions = createSelector([selectUser], user => user.userPermissions)

export const selectUserAddresses = createSelector([selectUser], user => user.userAddresses)

export const selectSignInAuth = createSelector([selectUser], user => user.signInAuth)

export const selectSignInAttemptExpired = createSelector([selectUser], user => user.signInAttemptExpired)

export const selectCompaniesRegistrationFee = createSelector([selectUser], user => user.companiesRegistrationFee)
export const selectIdentityLimits = createSelector([selectUser], user => user.identityLimits)

export const selectSumsubDocumentsSubmitted = createSelector([selectUser], user => user.sumsubDocumentsSubmitted)
